import React from 'react';
import PropTypes from 'prop-types';

import star from '../../../../../images/membership-star.png';
import Money from '../../../common/money';

const MembershipDiscountTooltip = ({ discounts }) => (
  <div className="c-membership-discount-tooltip">
    <div className="c-membership-discount-tooltip__header">
      Discount details
    </div>
    {
      discounts.map(discount => (
        <div key={discount.itemId} className="c-membership-discount-tooltip__item">
          <img src={star} width="30" height="30" />
          <div className="c-membership-discount-tooltip__item-info">
            <div>{discount.itemName}</div>
            <div display-if={discount.remainingQuantity === -1}>Unlimited quantity</div>
            <div display-if={discount.remainingQuantity !== -1}>
              {discount.remainingQuantity} out of {discount.totalQuantity} remaining in the membership
            </div>
          </div>
          <div className="u-type--semibold">
            <Money>{discount.amount}</Money>
          </div>
        </div>
      ))
    }
  </div>
);

MembershipDiscountTooltip.propTypes = {
  discounts: PropTypes.array.isRequired,
};

export default MembershipDiscountTooltip;
